import React, { useState, useEffect, useRef, useContext } from "react";
import { Link } from "react-router-dom";

// context
import { UserContext } from "../../Context/UserContextProvider";

// styles
import Dstyles from "./NavbarDropDown.module.css";
import NavStyles from "./Navbar.module.css";

export default function NavbarDropDown(props) {
  const { permissions } = useContext(UserContext);

  const [showLists, setShowLists] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  function handleClickOutside(event) {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowLists(false);
    }
  }

  return (
    <>
      <button className={Dstyles.container} onClick={() => setShowLists(!showLists)} ref={dropdownRef}>
        <div
          className="d-flex align-items-center justify-content-start me-0"
          style={{
            gap: "5px",
          }}>
          {props.consultant ? (
            <img
              className={NavStyles.user_img}
              loading="lazy"
              src={`https://backdev.azrmelk.com/images/users/avatar/${props?.avatarName?.replace("images/users/avatar/", "") || "avatar.png"}`}
              alt="user-profile"
            />
          ) : (
            <img
              className={NavStyles.user_img}
              loading="lazy"
              src={`https://backdev.azrmelk.com/images/users/avatar/${props?.avatarName?.replace("images/users/avatar/", "") || "avatar.png"}`}
              alt="user-profile"
            />
          )}
          <div className={`d-flex align-items-center justify-content-center ${NavStyles.text1}`} dir="rtl">
            {props?.fullName || JSON.parse(localStorage.getItem("userData")).name + " " + JSON.parse(localStorage.getItem("userData")).family}
          </div>
        </div>
        {showLists === true && (
          <ul className={`w-100 d-flex flex-column align-item-start justify-content-start py-2 px-3 ${Dstyles.dropdown_box_container}`}>
            {props.consultant ? (
              <>
                {permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 18) === 18 ? (
                  <Link to="/DashboardMain" className={`w-100 d-flex align-items-center justify-content-start my-2 ${Dstyles.drop_down_item}`} dir="rtl">
                    <li className={Dstyles.text1}>داشبورد</li>
                  </Link>
                ) : (
                  permissions?.find(item => item === 16) === 16 && (
                    <Link to="/FileManagement" className={`w-100 d-flex align-items-center justify-content-start my-2 ${Dstyles.drop_down_item}`} dir="rtl">
                      <li className={Dstyles.text1}>پنل مشاور</li>
                    </Link>
                  )
                )}
                <Link to="/user-profile" className={`w-100 d-flex align-items-center justify-content-start my-2 ${Dstyles.drop_down_item}`} dir="rtl">
                  <li className={Dstyles.text1}>پروفایل کاربری</li>
                </Link>
              </>
            ) : (
              <Link to="/user-profile" className={`w-100 d-flex align-items-center justify-content-start my-2 ${Dstyles.drop_down_item}`} dir="rtl">
                <li className={Dstyles.text1}>پروفایل کاربری</li>
              </Link>
            )}
            <li
              onClick={() => props.setShowModal(true)}
              className={`w-100 d-flex align-items-center justify-content-start my-2 ${Dstyles.drop_down_item}`}
              dir="rtl">
              <div className={`text-danger pointer ${Dstyles.text1}`}>خروج</div>
            </li>
          </ul>
        )}
      </button>
    </>
  );
}
